import { DeliveryPolicy, Money } from "../../ordering";
/**
 * Service for checking goegraphical information about the order, such as if the restaurant deliver to an address.
 */
export class GeocodingService {
    constructor(params) {
        this.rpcService = params.rpcService;
    }
    /**
     * @returns does the restaurant deliver to the provided address, how much will the delivery cost, how far away is the restaruant from the provided address
     */
    async getAddressInfo(restaurantId, address) {
        const response = await this.rpcService.rpc("GetAddressInfoRequest", {
            address,
            restaurantId: restaurantId.value,
        });
        return {
            coordinates: response.coordinates,
            distance: response.distance,
            deliveryInfo: response.deliveryInfo !== null
                ? {
                    zoneName: response.deliveryInfo.zoneName,
                    averageTime: response.deliveryInfo.averageTime,
                    distance: response.deliveryInfo.distance,
                    deliveryCost: Money.fromBackend(response.deliveryInfo.deliveryCost),
                    minOrderValue: Money.fromBackend(response.deliveryInfo.minOrderValue),
                    freeDeliveryThreshold: response.deliveryInfo.freeDeliveryThreshold === null
                        ? null
                        : Money.fromBackend(response.deliveryInfo.freeDeliveryThreshold),
                }
                : null,
        };
    }
    async geocode(country, address) {
        const result = await this.rpcService.rpc("GeocodeRequest", {
            streetAddress: address,
            country,
            accountId: null,
            restaurantId: null,
            fromPS: true,
        });
        return result.coordinates;
    }
    async getDeliveryPolicy(restaurantId, address) {
        if (address === null ||
            address.city.length === 0 ||
            address.street.length === 0 ||
            address.streetNumber.length === 0) {
            return DeliveryPolicy.Impossible;
        }
        const { deliveryInfo } = await this.getAddressInfo(restaurantId, address);
        if (deliveryInfo === null) {
            return DeliveryPolicy.Impossible;
        }
        return DeliveryPolicy.paid({
            cost: deliveryInfo.deliveryCost,
            freeDeliveryThreshold: deliveryInfo.freeDeliveryThreshold,
            minOrderValue: deliveryInfo.minOrderValue,
        });
    }
    async reverseGeocode(restaurantId, coordinates) {
        var _a;
        const response = await this.rpcService.rpc("ReverseGeocodeRequest", {
            coordinates,
            restaurantId: (_a = restaurantId === null || restaurantId === void 0 ? void 0 : restaurantId.value) !== null && _a !== void 0 ? _a : null,
        });
        return response.streetAddress;
    }
}
